/**
 *
 * AudiencesTable
 *
 */
import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Link, useParams } from 'react-router-dom';

// styles
import './style.scss';

// antd component
import { Button, Popconfirm } from 'antd';

// assets
import { DeleteOutlined } from '@ant-design/icons';
//import CustomIcons from 'components/CustomIcons';

// components
import CustomTable from 'components/CustomTable';
import TCFModal from 'components/TCFModal';
import { NotificationSimple } from 'components/Notifications';

// utils
import { USER_TYPES } from 'utils/helpers/helper.constant';

function AudiencesTable({
  dataSource,
  isLoading,
  // default
  editable,
  editMode,
  // actions
  onRemoveRow,
  // props
  className,
  ...rest
}) {
  const childClassNames = classNames('audiences-list-table', className);

  const [showSuccess, setShowSuccess] = useState(false);

  const actionsColumn = {
    title: 'Action',
    dataIndex: 'action',
    key: 'action-column-student',
    className: 'column-actions',
    render: (_, record) => {
      return (
        <Popconfirm
          placement="top"
          title="Voulez-vous vraiment supprimer?"
          okText="Oui"
          cancelText="Non"
          onConfirm={() => { 
            !!onRemoveRow && onRemoveRow(record);
            setShowSuccess(true);
          }}
          overlayClassName="popconfirm-window audiences-table-popconfirm"
        >
          <DeleteOutlined className="delete-action" />
        </Popconfirm>
      );
    },
  };

  const statusColumn = {
    title: 'Status',
    dataIndex: 'status',
    key: 'column-status',
    className: 'column-status',
    render: (_, record) => record?.status?.value && (
      <span className={`table-status ${record?.status?.value}`}>{record?.status?.label}</span>
    ),
  };

  const columns = [
    {
      title: 'Nom',
      dataIndex: 'lastname',
      key: 'column-lastname',
      className: 'column-lastname',
      sorter: (a, b) => a?.lastname?.localeCompare(b?.lastname),
      render: (text, record) => record?.lastname,
    },
    {
      title: 'Prénom',
      dataIndex: 'firstname',
      key: 'column-firstname',
      className: 'column-firstname',
      sorter: (a, b) => a?.firstname?.localeCompare(b?.firstname),
      render: (text, record, index) => record?.firstname,
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'column-type',
      className: 'column-type',
      sorter: (a, b) => a?.type?.localeCompare(b?.type),
      render: (text, record, index) => record?.type,
    },
    {
      title: 'Classe',
      dataIndex: 'className',
      key: 'column-class',
      className: 'column-class',
      sorter: (a, b) =>
        a?.class_info?.title?.localeCompare(b?.class_info?.title),
      render: (text, record, index) => {
        return record?.class_info?._id ? (
          <Link
            className="link-table"
            to={`/classes/${record?.class_info?._id}`}
          >
            {record?.class_info?.title}
          </Link>
        ) : (
          ''
        );
      },
    },
  ];

  const [tableColumns, setTableColumns] = useState(columns || []);

  // If mode was changes, change inner mode
  useEffect(() => {
    const cols = tableColumns.filter(
      col => col?.dataIndex != 'action' && col?.dataIndex !='status'
    );
    if (!!editable) {
      if (!!editMode) {
        cols.push(actionsColumn);
        setTableColumns(cols);
      } else {
        cols.push(statusColumn);
        setTableColumns(cols);
      }
    } else {
      setTableColumns(cols);
    }
  
  }, [editable, editMode]);

  return (
    <>
      <NotificationSimple
     //   Loading={isLoading}
        Successful={showSuccess}
        message="Durant!"
        messageSuccess="Membre supprimé!"
        description=""
        type="delete"
      />
      <CustomTable
        className={childClassNames}
        dataSource={dataSource || []}
        columns={tableColumns}
        loading={isLoading}
      />
    </>
  );
}

AudiencesTable.defaultProps = {
  editMode: false,
  dataSource: [],
  isLoading: false,
};
AudiencesTable.propTypes = {
  onRemoveRow: PropTypes.func,
};

export default AudiencesTable;
